// DATA
export const getETLibraryData = state => state.emailTemplatesLibrary.get('data')
export const getETLibraryPublicTemplates = state => getETLibraryData(state).get('publicTemplates')
export const getETLibraryPrivateTemplates = state => getETLibraryData(state).get('privateTemplates')
export const getETLibraryTemplateFormData = state => getETLibraryData(state).get('templateFormData')

// UI
export const getETLibraryUi = state => state.emailTemplatesLibrary.get('ui')
export const getETLibraryShowEditorDialog = state => getETLibraryUi(state).get('showEditorDialog')
export const getETLibraryShowSaveDialog = state => getETLibraryUi(state).get('showSaveDialog')
export const getETLibraryFetchRequestRunning = state => getETLibraryUi(state).get('fetchRequestRunning')
export const getETLibraryFetchAllRequestRunning = state => getETLibraryUi(state).get('fetchReleasedRequestRunning')
export const getETLibrarySaveRequestRunning = state => getETLibraryUi(state).get('saveRequestRunning')
export const getETLibraryDeleteRequestRunning = state => getETLibraryUi(state).get('deleteRequestRunning')
export const getETLibraryShowPublic = state => getETLibraryUi(state).get('showPublic')
export const getETLibraryDeleteDialogOpen = state => getETLibraryUi(state).get('deleteDialogOpen')
export const getETLibraryTemplateToDelete = state => getETLibraryUi(state).get('templateToDelete')

// FILTERS
export const getETLibraryFilter = state => state.emailTemplatesLibrary.get('filter')

// ADDITIONAL
export const getETLibraryTemplates = state => {
  const showPublic = getETLibraryShowPublic(state)

  return showPublic ? getETLibraryPublicTemplates(state) : getETLibraryPrivateTemplates(state)
}
